import styled from "styled-components";
import { CSSVars } from "@/styles/styles.config";

export const StyledSection = styled.section`
  background: linear-gradient(120deg, #1f1f5c 0%, #4a2e6b 50%, #5c3340 100%);
  color: ${CSSVars.white};
  padding: 80px 20px;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background:
      radial-gradient(circle at 20% 30%, rgba(91, 91, 255, 0.4) 0%, transparent 45%),
      radial-gradient(circle at 80% 70%, rgba(245, 138, 138, 0.3) 0%, transparent 45%),
      radial-gradient(circle at 50% 100%, rgba(166, 108, 217, 0.35) 0%, transparent 50%);
    pointer-events: none;
  }

  @media screen and (min-width: ${CSSVars.breakpointMD}) {
    padding: 100px 30px;
  }
  @media screen and (min-width: ${CSSVars.breakpointLG}) {
    padding: 120px 40px;
  }

  .inner {
    max-width: 1240px;
    margin: 0 auto;
    position: relative;
    z-index: 1;
  }

  header {
    text-align: center;
    margin-bottom: 56px;

    @media screen and (min-width: ${CSSVars.breakpointLG}) {
      margin-bottom: 72px;
    }
  }

  .eyebrow {
    display: inline-block;
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(8px);
    color: #c2cfff;
    font-family: ${CSSVars.primaryFont};
    font-weight: 600;
    font-size: 12px;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    padding: 6px 14px;
    border-radius: 999px;
    margin-bottom: 14px;
    border: 1px solid rgba(255, 255, 255, 0.15);
  }

  h2 {
    font-family: ${CSSVars.primaryFont};
    font-weight: 700;
    font-size: 30px;
    line-height: 1.15;
    letter-spacing: -0.02em;
    color: ${CSSVars.white};
    margin: 0;

    @media screen and (min-width: ${CSSVars.breakpointMD}) {
      font-size: 40px;
    }
    @media screen and (min-width: ${CSSVars.breakpointLG}) {
      font-size: 48px;
    }
  }

  .steps {
    list-style: none;
    margin: 0;
    padding: 0;
    display: grid;
    grid-template-columns: 1fr;
    gap: 24px;
    counter-reset: step;

    @media screen and (min-width: ${CSSVars.breakpointMD}) {
      grid-template-columns: repeat(3, 1fr);
      gap: 24px;
      position: relative;
    }
  }

  .step {
    background: rgba(255, 255, 255, 0.06);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 18px;
    padding: 28px 26px;
    position: relative;
    transition: transform 0.25s ease, border-color 0.25s ease,
      background 0.25s ease;

    @media screen and (min-width: ${CSSVars.breakpointLG}) {
      padding: 36px 32px;
    }

    &:hover {
      transform: translateY(-3px);
      border-color: rgba(255, 151, 156, 0.4);
      background: rgba(255, 255, 255, 0.08);
    }

    .num {
      display: inline-block;
      font-family: ${CSSVars.primaryFont};
      font-weight: 700;
      font-size: 32px;
      background: linear-gradient(135deg, ${CSSVars.pink300} 0%, ${CSSVars.purple500} 50%, ${CSSVars.blue500} 100%);
      -webkit-background-clip: text;
      background-clip: text;
      -webkit-text-fill-color: transparent;
      letter-spacing: -0.02em;
      margin-bottom: 12px;
      line-height: 1;
    }

    h3 {
      font-family: ${CSSVars.primaryFont};
      font-weight: 600;
      font-size: 19px;
      line-height: 1.3;
      letter-spacing: -0.01em;
      color: ${CSSVars.white};
      margin: 0 0 10px;

      @media screen and (min-width: ${CSSVars.breakpointMD}) {
        font-size: 21px;
      }
    }

    p {
      font-family: ${CSSVars.secondaryFont};
      font-weight: 400;
      font-size: 15px;
      line-height: 1.65;
      color: #c2cfff;
      margin: 0;
    }
  }

  .cta {
    display: flex;
    align-items: center;
    gap: 8px;
    width: fit-content;
    margin: 56px auto 0;
    font-family: ${CSSVars.primaryFont};
    font-weight: 600;
    font-size: 16px;
    color: ${CSSVars.white};
    text-decoration: none;
    padding: 14px 28px;
    border-radius: 999px;
    background: linear-gradient(270deg, ${CSSVars.pink300} 0%, ${CSSVars.purple500} 50%, ${CSSVars.blue500} 100%);
    background-size: 200% 100%;
    background-position: 100% 0;
    transition: background-position 0.4s ease, transform 0.2s ease,
      box-shadow 0.2s ease;
    box-shadow: 0 8px 28px rgba(76, 79, 255, 0.4);

    &:hover {
      background-position: 0 0;
      transform: translateY(-1px);
      box-shadow: 0 12px 36px rgba(255, 151, 156, 0.45);
    }

    span {
      transition: transform 0.2s ease;
    }
    &:hover span {
      transform: translateX(3px);
    }
  }
`;
